import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { RecipeSummary } from '../hooks/useRecipes';

interface RecipeCardProps {
  recipe: RecipeSummary;
}

export function RecipeCard({ recipe }: RecipeCardProps) {
  const basePath = `/a/arche_crafting/recipes/${recipe.recipeId}`;

  return (
    <Link to={basePath} className="block">
      <Card className="h-full hover:border-primary/50 transition-colors">
        <CardHeader className="pb-2">
          <div className="flex items-start justify-between gap-2">
            <CardTitle className="text-base line-clamp-1">{recipe.name}</CardTitle>
            <div className="flex gap-1 shrink-0">
              <Badge variant="outline" className="text-xs">
                {recipe.recipeType}
              </Badge>
              {!recipe.isEnabled && (
                <Badge variant="destructive" className="text-xs">
                  Disabled
                </Badge>
              )}
              {recipe.requiresLearned && (
                <Badge variant="secondary" className="text-xs">
                  Learnable
                </Badge>
              )}
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {recipe.description && (
            <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{recipe.description}</p>
          )}
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span>
              {recipe.inputs.length} input{recipe.inputs.length !== 1 ? 's' : ''}
            </span>
            <span>
              {recipe.outputs.length} output{recipe.outputs.length !== 1 ? 's' : ''}
            </span>
            {recipe.level > 0 && <span>Level {recipe.level}</span>}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
